import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { UserProfile } from "../types";

export type UserProfileCardProps = {
  user: UserProfile;
  onEditRole: () => void;
  canEditRole: boolean;
};

export function UserProfileCard({
  user,
  onEditRole,
  canEditRole,
}: UserProfileCardProps) {
  return (
    <Paper
      sx={{
        p: 3,
        mb: 4,
        borderRadius: 2,
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 3 }}>
        User profile
      </Typography>

      <Grid container columnSpacing={3} rowSpacing={3}>
        {/* Name field */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 1, fontWeight: 500 }}
          >
            Name
          </Typography>
          <TextField fullWidth size="small" value={user.name} disabled />
        </Grid>

        {/* Email field */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 1, fontWeight: 500 }}
          >
            Email address
          </Typography>
          <TextField
            fullWidth
            size="small"
            value={user.email}
            disabled
            type="email"
          />
        </Grid>

        {/* Organizational role */}
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mb: 1, fontWeight: 500 }}
          >
            Organizational role
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              p: 1.5,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
            }}
          >
            <Typography sx={{ flex: 1 }}>
              {user.organizationRole.title}
            </Typography>
            {canEditRole && (
              <Button
                variant="outlined"
                color="primary"
                size="small"
                onClick={onEditRole}
                sx={{ textTransform: "uppercase" }}
              >
                Edit Role
              </Button>
            )}
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
